import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

function comparator (a, b) {
  if (a.nombre > b.nombre) return 1
  if (a.nombre < b.nombre) return -1
  return 0
}

// Parche para evitar que se rompa el select de cereales en operaciones de silo, ya que el endpoint de cereales habilitados a veces falla. De esta forma,
// si falla, se muestra un select vacío pero funcional, y no se rompe toda la pantalla de operaciones de silo.
// export const fetchCereales = async () => lrsAdapter(await getAxiosInstance().get(`/cereal_habilitado?=r{}`)).data.sort(comparator)
export const fetchCereales = async () => lrsAdapter(await getAxiosInstance().get(`/cereal_con_deshabilitados?=r{}`)).data.sort(comparator)

class Cereal {
  static async getDatosCereal (claveCereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cereal?r=` +
    `{"clave":{"nombre_corto":"${claveCereal}"}}`)

    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    console.log('Cereal', response)
    return response.data[0]
  }

  static async getNombreCorto (nombre) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cereal_nombre?r=` +
    `{"clave":{"nombre":"${nombre}"}}`)

    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data[0]
  }

  addCereal (formValues) {
    const axios = getAxiosInstance()
    const valores = {
      nombre_corto: formValues.nombreCorto.toUpperCase(),
      nombre: formValues.nombreCereal,
      peso_especifico: formValues.pesoEspecifico || null,
      limite_de_humedad: formValues.humedad,
      codigo_afip: formValues.codigoARCA || null,
      color: formValues.color || null,
      codigo_interno: formValues.codigoInterno || 100,
      habilitado: formValues.habilitado,
      codigo_camara_arbitral: formValues.codigoCamaraArbitral || null,
      codigo_analisis: formValues.codigoAnalisis || null,
      grupo_ensayo: formValues.grupoEnsayo || null,
      grupo_ensayo_embarque: formValues.grupoEnsayoEmbarque || null
    }
    const promise = axios.post(`cereal`, { valores: { ...valores } })
    return promise.then(lrsAdapter)
      .then((result) => result)
      .catch(lrsAdapter)
  }

  updateCereal (nombreCorto, formValues) {
    const axios = getAxiosInstance()
    const valores = {
      peso_especifico: formValues.pesoEspecifico || null,
      limite_de_humedad: formValues.humedad,
      codigo_afip: formValues.codigoARCA || null,
      color: formValues.color || null,
      codigo_interno: formValues.codigoInterno || 100,
      habilitado: formValues.habilitado,
      codigo_camara_arbitral: formValues.codigoCamaraArbitral || null,
      codigo_analisis: formValues.codigoAnalisis || null,
      grupo_ensayo: formValues.grupoEnsayo || null,
      grupo_ensayo_embarque: formValues.grupoEnsayoEmbarque || null
    }
    console.log(valores)
    const promise = axios.put(`cereal`, { valores: { ...valores }, clave: { nombre_corto: nombreCorto } })
    return promise.then(lrsAdapter)
      .then((result) => result)
      .catch(lrsAdapter)
  }

  deleteCereal (nombreCorto) {
    const axios = getAxiosInstance()
    const filtro = `{"clave": {"nombre_corto": "${nombreCorto}"}}`
    const promise = axios.delete(`cereal?r=${filtro}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }

  getCerealesTodos () {
    const axios = getAxiosInstance()
    const filtro = JSON.stringify({ orden: ['d:nombre_corto'] })
    const promise = axios.get(`cereal_listado?r=${filtro}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static async getCereales () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cereal_habilitado?=r{}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data.sort(comparator)
  }

  static async getCerealesConDeshabilitados () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cereal_con_deshabilitados?=r{}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data.sort(comparator)
  }

  static getEstadoPedidosCereal () {
    const axios = getAxiosInstance()
    const promise = axios.get(`corte_de_pedido_de_calado_pendiente`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static submitCortePedidoCalado (fechaDeCorte, cereal) {
    const axios = getAxiosInstance()
    const promise = axios.post(`corte_de_pedido_de_calado_pendiente`, `{"valores": {"fecha_de_corte": "${fechaDeCorte}", "cereal": "${cereal}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
  }

  static deleteCortePedidoCalado (fechaDeCorte, cereal) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`corte_de_pedido_de_calado_pendiente?r=` +
      `{"clave": {"fecha_de_corte": "${fechaDeCorte}", "cereal": "${cereal}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
  }
}

export default Cereal
